import { EaseMove, EaseMoveTo, EaseMoveFrom, EaseMoveMethods } from '../../../plugins/easemove.js';
export { EaseMove, EaseMoveTo, EaseMoveFrom, EaseMoveMethods };